import { useState } from 'react'
import styled from '@emotion/styled'
import Row from 'antd/lib/row'
import Col from 'antd/lib/col'
import { useHistory } from 'react-router-dom'

import Card from './Card'

const AboutUsPage = () => {
  const history = useHistory()
  const [advantageCurrent, setAdvantageCurrent] = useState(1)

  const handleClickAdvantage = (showNumber) => {
    if (showNumber === advantageCurrent) {
      setAdvantageCurrent(0)
      return null
    }
    setAdvantageCurrent(showNumber)
  }

  const showDetail = (showNumber) => showNumber === advantageCurrent

  return (
    <Page>
      <div className='intro-finnovo'>
        <img class='intro-finnovo-bg' src='/finnovo/intro-fin.jpg' alt='' />
        <div className='intro-finnovo-content'>
          <div className='compony-name'>Finnovo Lending Solutions</div>
          <div className='intro-compony-info'>We deliver end-to-end Lending Software</div>
          <div className='intro-compony-info'>
            for Financial Institutions and Alternative Lenders.
          </div>
        </div>
      </div>
      <div className='compony-product'>
        <Row className='full-width'>
          <Col sm={24} md={12} lg={12} xl={12} className='card-padding'>
            <Card
              title='LOS'
              infoTitle='Loan Origination System'
              info='Our loan origination module allows lending providers to 
                  automate the client onboarding and loan underwriting process, 
                  resulting in optimized conversion rate, minimizing approval time and 
                  maximizing the opportunity of qualified clients into your portfolio.'
              imgIcon='/finnovo/los-img.png'
              learnMoreClick={() => history.push('/los')}
            />
          </Col>
          <Col sm={24} md={12} lg={12} xl={12} className='card-padding'>
            <Card
              title='LMS'
              infoTitle='Loan Management System'
              info='Our loan management module empowers lending providers to design, 
                  configure, test and release loan products in a short timeframe, which 
                  allows providers to anticipate and respond to the evolving market needs.'
              imgIcon='/finnovo/lms-img.png'
              learnMoreClick={() => history.push('/lms')}
            />
          </Col>
          <Col sm={24} md={12} lg={12} xl={12} className='card-padding'>
            <Card
              title='CMS'
              infoTitle='Card Management System'
              info='Our card management module enables lending providers to facilitate 
                  borrowers in withdrawing loans credit with complete security. The module 
                  manages the total lifecycle of lending cards from issuance, maintenance 
                  until end-of-life. This module is endorsed by the highest up-to-date security 
                  standard (3DES, EMV) and it is continually updated to keep up with the highest world security standard.'
              imgIcon='/finnovo/cms-img.png'
            />
          </Col>
          <Col sm={24} md={12} lg={12} xl={12} className='card-padding'>
            <Card
              title='CS'
              infoTitle='Collection System'
              info='Our collector module gives the lending providers the ability to manage 
                  and shorten the debt collection process. It allows the lending providers to 
                  categorize the debtors into debt status, set debt collection KPIs, monitor the 
                  collectors’ performance against each group of debtors and incentivizes the collectors 
                  to manage their debtors more effectively.'
              imgIcon='/finnovo/cs-img.png'
            />
          </Col>
        </Row>
      </div>

      <div className='advantage'>
        <div className='advantage-title'>ADVANTAGE</div>
        <div className='advantage-content'>
          <div className='advantage-content-label advantage-content-label-title'>Advantage</div>
          <Row>
            <Col sm={24} md={24} lg={12} xl={12}>
              <div className='advantage-content-label'>
                <div className='focus' onClick={() => handleClickAdvantage(1)}>
                  Modular Design
                </div>
                {showDetail(1) && (
                  <div className='none-focus'>
                    Prebuilt modules so that you can pick and choose what to use and able to launch
                    the system in short timeframe. Each module can be integrated and worked in
                    Straight-through Process.
                  </div>
                )}

                <div className='focus' onClick={() => handleClickAdvantage(2)}>
                  Configuration-based Design
                </div>
                {showDetail(2) && (
                  <div className='none-focus'>
                    Every commonly used attributes are designed as parameters for users to configure
                    easily in GUI based so that products and processes can be easily adjusted to
                    suit your business.
                  </div>
                )}

                <div className='focus' onClick={() => handleClickAdvantage(3)}>
                  Scalable
                </div>
                {showDetail(3) && (
                  <div className='none-focus'>
                    Designed and developed on Container-based technology therefore it can be scale
                    as the workload grows and can be installed and implemented in any environment.
                  </div>
                )}

                <div className='focus' onClick={() => handleClickAdvantage(4)}>
                  Integration with 3rd Party
                </div>
                {showDetail(4) && (
                  <div className='none-focus'>
                    Allow online integration via API or bulk file with 3rd party system to increase
                    flexibility and easy operation.
                  </div>
                )}
              </div>
            </Col>
            <Col sm={24} md={24} lg={12} xl={12}>
              <div className='advantage-content-img'>
                <img alt='' src='/finnovo/977.jpg' />
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className='about-us-p'>
        <div className='about-us-title'>About Us</div>
        <div className='about-us-content'>
          <div>
            Founded by a group of experienced Banking executives and seasoned Technologists in the
            financial field whose vision is to create innovative lending solutions with
            international standard that fits today’s fast moving business environment, regardless of
            lender’s businesssize – from Banks to Non-banks and alternative lenders.
          </div>
        </div>

        <div className='about-us-content'>
          <div>
            Our aspiration is to innovate the way that lending is operated in within the financial
            eco- system and become a trusted technology partner with lending institutions worldwide.
            We believe in long-term partnership with our clients, by delivering a quality package
            which empowers our clients to operate and evolve their offerings to respond to the
            market needs.
          </div>
        </div>
      </div>

      <div className='contact-us'>
        <div className='contact-us-header'>
          <div className='contact-us-title'>CONTACT US</div>
          <div className='contact-us-title-on'>CONTACT US</div>
        </div>
        <div className='contract-content'>
          <div className='contract-content-item'>
            <div className='contract-item-header'>
              <div className='image-border'>
                <img alt='' src='/finnovo/contract-location.svg' />
              </div>
            </div>
            <div className='contract-content-item-title'>Location</div>
            <div className='contract-content-item-detail'>
              3 Promphan 3 Building, Room 1707-1708, 17th Floor, Soi Ladprao 3, Chomphon, Chatuchak,
              Bangkok 10900 Thailand
            </div>
          </div>

          <div className='contract-content-item'>
            <div className='contract-item-header'>
              <div className='image-border'>
                <img alt='' src='/finnovo/contract-phone.svg' />
              </div>
            </div>
            <div className='contract-content-item-title'>Phone</div>
            <div className='contract-content-item-detail'>+669 0989 6177</div>
          </div>

          <div className='contract-content-item'>
            <div className='contract-item-header'>
              <div className='image-border'>
                <img alt='' src='/finnovo/contract-mail.svg' />
              </div>
            </div>
            <div className='contract-content-item-title'>Mail</div>
            <div className='contract-content-item-detail'>sopon.d@finnovo.co</div>
          </div>
        </div>
      </div>
    </Page>
  )
}
const Page = styled.div`
  .intro-finnovo {
    height: 500px;

    .intro-finnovo-bg {
      opacity: 0.6;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 700px;
      object-fit: cover;
    }
    .intro-finnovo-content {
      position: relative;
      padding: 40px;
      left: 50%;
      top: 50%;
      transform: translateY(-50%) translateX(-50%);
      text-align: center;

      .compony-name {
        @media only screen and (max-width: 700px) {
          font-size: 30px;
        }
        color: #1564c0;
        font-weight: bold;
        font-size: 50px;
        padding: 20px 0;
      }
      .intro-compony-info {
        @media only screen and (max-width: 700px) {
          font-size: 18px;
        }
        font-size: 20px;
      }
    }
  }

  .compony-product {
    @media only screen and (max-width: 700px) {
      padding: 0 20px;
    }
    width: 100%;
    z-index: 1;
    padding: 0 66px;
    margin-top: -60px;
    .card-padding {
      padding: 0 20px;
      margin: 10px 0;
    }
  }

  .advantage {
    margin: 50px 0 0;
    .advantage-title {
      @media only screen and (max-width: 700px) {
        font: normal normal bold 55px/41px PoppinsRegular;
      }
      font: normal normal bold 160px/118px PoppinsRegular;
      color: #f1f1f1;
    }

    .advantage-content {
      @media only screen and (max-width: 700px) {
        /* height: 500px; */
        padding: 20px;
      }
      padding: 40px;
      background-color: #170039;
      /* background-image: url('/finnovo/advantage.jpg'); */
      /* background-size: cover; */
      /* min-height: 700px; */

      .advantage-content-label {
        padding: 20px 0;
        color: #ffffff;
        /* display: flex; */
        .focus {
          @media only screen and (max-width: 700px) {
            font-size: 20px;
          }
          font-size: 28px;
          cursor: pointer;
          text-decoration: underline;
        }
        .none-focus {
          /* @media only screen and (max-width: 700px) {
            font-size: 16px;
          } */
          font-size: 16px;
          color: #949494;
        }
      }
      .advantage-content-label-title {
        @media only screen and (max-width: 700px) {
          font-size: 30px;
        }
        font-size: 35px;
        font-weight: bold;
        line-height: 1.5;
        display: flex;
        justify-content: center;
      }
      .advantage-content-img {
        text-align: center;
        img {
          width: 80%;
        }
      }
    }
  }

  .about-us-p {
    @media only screen and (max-width: 700px) {
      padding: 50px;
    }
    text-align: center;
    padding: 50px 160px;
    .about-us-title {
      @media only screen and (max-width: 700px) {
        font-size: 30px;
      }
      font-size: 42px;
      font-weight: bold;
      color: #1564c0;
    }
    .about-us-content {
      @media only screen and (max-width: 700px) {
        font-size: 14px;
        padding: 10px 0;
      }
      padding: 30px 0px;
      font-size: 16px;
    }
  }

  .contact-us {
    text-align: center;
    background-color: #f3f9ff;
    .contact-us-header {
      @media only screen and (max-width: 700px) {
        padding: 20px 20px 0;
      }
      padding: 20px;
      background-color: #ffffff;
      .contact-us-title {
        @media only screen and (max-width: 700px) {
          font: normal normal bold 50px/41px PoppinsRegular;
        }
        font: normal normal bold 160px/97px PoppinsRegular;
        color: #f3f9ff;
      }
      .contact-us-title-on {
        @media only screen and (max-width: 700px) {
          margin-top: -33px;
          font-size: 20px;
        }
        margin-top: -60px;
        color: #1564c0;
        font-weight: bold;
        font-size: 30px;
      }
    }
    .contract-content {
      @media only screen and (max-width: 700px) {
        padding: 20px 0;
      }
      padding: 30px 0;
      display: flex;
      text-align: center;
      justify-content: center;
      .contract-content-item {
        padding: 20px;
        width: 400px;
        text-align: center;
        .contract-item-header {
          display: flex;
          justify-content: center;
          .image-border {
            @media only screen and (max-width: 700px) {
              width: 66px;
            }
            width: 112px;
            background-color: #1564c0;
            padding: 20px;
            border-radius: 55px;
            img {
              @media only screen and (max-width: 700px) {
                width: 26px;
              }
              width: 70px;
              height: auto;
              filter: brightness(0) invert(1);
            }
          }
        }
        .contract-content-item-title {
          @media only screen and (max-width: 700px) {
            font-size: 16px;
            padding: 10px 0;
          }
          color: #1564c0;
          font-size: 18px;
          font-weight: bold;
          padding: 20px 0 10px 0;
        }
        .contract-content-item-detail {
          font-size: 14px;
        }
      }
    }
  }
`

export default AboutUsPage
